/* eslint-disable react/prop-types */
import { getSVGRectPositioning } from 'bam-node-baseball-savant/constants/zone.ts'
import React from 'react'
import * as d3 from 'd3'

const defaultStrokeWidth = 4

const defaultStyles: React.SVGProps<SVGRectElement> = {
    fill: '',
    stroke: '#333',
    fillOpacity: 0.001,
    strokeOpacity: 0.8,
    strokeDasharray: '8 2.5',
}

type StrikeZoneDumbProps = {
    xScale: d3.ScaleLinear<number, number>
    yScale: d3.ScaleLinear<number, number>
    szTop: number
    szBot: number
    plateWidthFt: number
    strokeWidth?: number
    styles?: React.SVGProps<SVGRectElement>
    fuzz?: boolean
}

export default function StrikeZoneDumb({
    fuzz = false,
    xScale,
    yScale,
    szTop,
    szBot,
    plateWidthFt,
    strokeWidth = defaultStrokeWidth,
    styles = {},
}: StrikeZoneDumbProps) {
    const { x, y, width, height } = getSVGRectPositioning(
        szTop,
        szBot,
        plateWidthFt,
        xScale,
        yScale,
        strokeWidth
    )

    const rectStyles = { ...defaultStyles, ...styles }

    return (
        <g className="strike-zone-wrapper">
            <rect
                className="strike-zone"
                style={{ pointerEvents: 'none' }}
                x={x}
                width={width}
                y={y}
                height={height}
                strokeWidth={defaultStrokeWidth}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...rectStyles}
                strokeOpacity={
                    typeof rectStyles.strokeOpacity === 'number'
                        ? rectStyles.strokeOpacity / 4
                        : 0.2
                }
                strokeDasharray="none"
            />
            <rect
                className="strike-zone"
                style={{ pointerEvents: 'none' }}
                x={x}
                width={width}
                y={y}
                height={height}
                strokeWidth={defaultStrokeWidth}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...rectStyles}
                filter={fuzz ? 'url(#fuzzFilter)' : ''}
            />
        </g>
    )
}
